import React from 'react'
import { SVGIcon } from '~/utils/types'


export const QuoteGradient = (props: SVGIcon) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 40">
    <defs>
      <linearGradient id="prefix__a" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#008DD1" />
        <stop offset="100%" stopColor="#5CB235" />
      </linearGradient>
    </defs>
    <path
      fill="none"
      fillRule="evenodd"
      stroke="url(#prefix__a)"
      d="M646.66 164.84c2.493 0 4.693-.825 6.6-2.475 1.907-1.65 2.86-3.942 2.86-6.875 0-2.493-.807-4.437-2.42-5.83-1.613-1.393-3.41-2.09-5.39-2.09-1.173 0-2.42.33-3.74.99-1.173.587-2.053.88-2.64.88-.66 0-1.137-.202-1.43-.605-.293-.403-.44-.862-.44-1.375 0-3.52 1.43-6.857 4.29-10.01 2.86-3.153 6.563-5.61 11.11-7.37h0l-1.54-3.08c-5.573 2.053-10.12 5.243-13.64 9.57-3.52 4.327-5.28 9.497-5.28 15.51 0 3.667 1.063 6.71 3.19 9.13 2.127 2.42 4.95 3.63 8.47 3.63zm27.8 0c2.493 0 4.693-.825 6.6-2.475 1.907-1.65 2.86-3.942 2.86-6.875 0-2.493-.807-4.437-2.42-5.83-1.613-1.393-3.41-2.09-5.39-2.09-1.173 0-2.42.33-3.74.99-1.173.587-2.053.88-2.64.88-.66 0-1.137-.202-1.43-.605-.293-.403-.44-.862-.44-1.375 0-3.52 1.43-6.857 4.29-10.01 2.86-3.153 6.563-5.61 11.11-7.37h0l-1.54-3.08c-5.573 2.053-10.12 5.243-13.64 9.57-3.52 4.327-5.28 9.497-5.28 15.51 0 3.667 1.063 6.71 3.19 9.13 2.127 2.42 4.95 3.63 8.47 3.63z"
      transform="translate(-634 -126)"
    />
  </svg>
)
